// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // serverUrl: "https://front-reachr-homewp-prod.azurewebsites.net",
  // serverUrl: "http://192.168.15.65",
  // https://www.reachr.com.br
  serverUrl: "https://www.reachr.com.br",
  serverApi: "https://api.reachr.com.br/api",
  // serverApi: "https://localhost:59355/api",
  serverToken: "https://api.reachr.com.br/token",
  facebookId: "665782150541011",
  google_analytics: "UA-74297941-1",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
